/* Hale & Hound product page: variant picker, bundle tiers, live price, fit line,
   real low-stock bar, gallery thumbs and sticky bar for sections/hh-pdp-main.liquid. */
(function () {
  function init(root) {
    if (root.dataset.hhpReady) return;
    root.dataset.hhpReady = '1';
    var dataEl = root.querySelector('[data-hhp-data]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var fmt;
    try { fmt = new Intl.NumberFormat(data.locale || undefined, { style: 'currency', currency: data.currency }); }
    catch (e) { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: data.currency || 'USD' }); }
    var money = function (cents) { return fmt.format(Math.round(cents) / 100); };

    var groups = $$('[data-hhp-option]');
    var mainImg = $('.main-img img');
    var thumbs = $$('[data-hhp-thumb]');
    var tierInputs = $$('.tier input');
    var form = $('form');
    var qtyInput = $('[data-hhp-qty]');
    var idInput = $('[data-hhp-variant-id]');
    var sticky = $('[data-hhp-sticky]');

    function selected() {
      return groups.map(function (g) {
        var b = g.querySelector('[aria-pressed="true"]');
        return b ? b.getAttribute('data-value') : null;
      });
    }
    function findVariant(sel) {
      return data.variants.find(function (v) {
        return sel.every(function (val, i) { return val === null || v.options[i] === val; });
      }) || data.variants[0];
    }
    function tier() {
      var t = tierInputs.find(function (i) { return i.checked; });
      return t ? { qty: +t.value || 1, disc: (+t.dataset.discount || 0) / 100, title: t.dataset.title } : { qty: 1, disc: 0, title: '' };
    }
    function total(v, q, d) { return Math.round(v.price * q * (1 - d)); }
    function groupValue(kind) {
      var g = groups.find(function (x) { return x.dataset.hhpKind === kind; });
      if (!g) return null;
      var b = g.querySelector('[aria-pressed="true"]');
      return b ? b.getAttribute('data-value') : null;
    }
    function shortSize(val) { return val ? val.split(' (')[0] : ''; }
    var track = $('[data-hhp-track]');
    var dots = $$('.m-dots i');
    function setMain(src) {
      if (track && src) {
        var slide = Array.prototype.find.call(track.children, function (s) { return s.getAttribute('data-src') === src; });
        if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      }
      if (!mainImg || !src) return;
      mainImg.removeAttribute('srcset');
      mainImg.removeAttribute('sizes');
      mainImg.src = src;
    }

    function fitText(sizeVal) {
      var guide = data.sizeGuide;
      if (!Array.isArray(guide) || !sizeVal) return '';
      var key = shortSize(sizeVal).toLowerCase();
      var row = guide.find(function (r) { return r && String(r.size || '').toLowerCase() === key; });
      if (!row) return '';
      if (row.fit) return String(row.fit);
      var out = [];
      if (row.dimensions) out.push(String(row.dimensions).replace(/\s+-\s+fits/i, '. Fits'));
      var who = '';
      if (row.weight) who = 'For dogs ' + row.weight;
      if (row.breeds) who += (who ? ', like ' : 'Good for ') + row.breeds;
      if (who) out.push(who);
      return out.join('. ') + (out.length ? '.' : '');
    }

    function render() {
      var v = findVariant(selected());
      var t = tier();
      var now = total(v, t.qty, t.disc);
      var unitWas = Math.max(v.compare || 0, v.price);
      var was = unitWas * t.qty;
      if (idInput) idInput.value = v.id;
      if (qtyInput && tierInputs.length) qtyInput.value = t.qty;

      var priceEl = $('[data-hhp-price]'), wasEl = $('[data-hhp-was]'), offEl = $('[data-hhp-off]');
      if (priceEl) priceEl.textContent = money(now);
      var showWas = was > now;
      if (wasEl) { wasEl.hidden = !showWas; wasEl.textContent = money(was); }
      if (offEl) { offEl.hidden = !showWas; offEl.textContent = 'Save ' + Math.round((1 - now / was) * 100) + '%'; }

      var sizeVal = groupValue('size');
      var sub = $('[data-hhp-price-sub]');
      if (sub) {
        var bits = [];
        if (t.qty > 1) bits.push((t.title || t.qty + ' items') + ', ' + money(now / t.qty) + ' each');
        else if (sizeVal) bits.push('Size ' + shortSize(sizeVal));
        if (data.freeShipping) bits.push(data.freeShipping);
        sub.textContent = bits.join(' · ');
      }
      var fit = $('[data-hhp-fit]');
      if (fit) fit.textContent = fitText(sizeVal);

      $$('[data-hhp-amt]').forEach(function (a) {
        var inp = a.parentElement.querySelector('input');
        var q = +inp.value || 1, d = (+inp.dataset.discount || 0) / 100, val = total(v, q, d);
        a.innerHTML = money(val) + '<small>' + (q > 1 ? money(val / q) + ' each' : '&nbsp;') + '</small>';
      });

      var colourName = $('[data-hhp-colour-name]');
      if (colourName) colourName.textContent = groupValue('colour') || '';

      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          var sel = selected(); sel[gi] = b.getAttribute('data-value');
          var match = data.variants.find(function (x) { return sel.every(function (val, i) { return x.options[i] === val; }); });
          b.setAttribute('data-unavailable', match && match.available ? 'false' : 'true');
        });
      });

      var stock = $('[data-hhp-stock]');
      if (stock) {
        // 1) real tracked inventory that is running low wins
        var low = v.inv !== null && v.inv > 0 && v.inv <= data.stockThreshold;
        var txt = '', width = 0;
        if (low) {
          var label = [groupValue('colour'), shortSize(sizeVal)].filter(Boolean).join(', ');
          txt = 'only ' + v.inv + ' left' + (label ? ' in ' + label : '');
          width = Math.round(v.inv / data.stockThreshold * 100);
        } else if (data.stockLabel) {
          // 2) otherwise the product's own stock message (custom.stock_label / stock_percent_sold)
          txt = String(data.stockLabel).replace(/\[colou?r\]/gi, groupValue('colour') || '').replace(/\s+in\s*$/, '');
          width = data.stockSold > 0 ? 100 - data.stockSold : 30;
        }
        stock.hidden = !txt;
        if (txt) {
          $('[data-hhp-stock-text]').textContent = txt;
          $('[data-hhp-stock-bar]').style.width = Math.min(100, Math.max(6, width)) + '%';
        }
      }

      $$('[data-hhp-add],[data-hhp-now],[data-hhp-sticky-add]').forEach(function (b) {
        b.disabled = !v.available;
        if (b.hasAttribute('data-hhp-add') || b.hasAttribute('data-hhp-sticky-add')) b.textContent = v.available ? 'Add to cart' : 'Sold out';
      });

      var ss = $('[data-hhp-sticky-sub]');
      if (ss) {
        var parts = [groupValue('colour'), shortSize(sizeVal)].filter(Boolean);
        if (t.qty > 1) parts.push(t.title || t.qty + ' items');
        parts.push(money(now));
        ss.innerHTML = '';
        ss.appendChild(document.createTextNode(parts.join(' · ')));
        if (showWas) { var w = document.createElement('span'); w.className = 'was'; w.textContent = money(was); ss.appendChild(w); }
      }

      return v;
    }

    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-value]');
        if (!b) return;
        g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        var v = render();
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (v.img) { setMain(v.img); thumbs.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); }); }
      });
    });
    tierInputs.forEach(function (i) { i.addEventListener('change', render); });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        setMain(b.getAttribute('data-hhp-thumb'));
      });
    });

    if (track && dots.length) {
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = requestAnimationFrame(function () {
          tick = null;
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          dots.forEach(function (d, n) { d.classList.toggle('on', n === i); });
        });
      }, { passive: true });
    }

    var addBtn = $('[data-hhp-add]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      var stickyBtn = sticky.querySelector('button');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
    }
    render();

    // delivery window: today + min..max business days (weekends skipped), in the shopper's locale
    var eta = $('[data-hhp-eta]');
    if (eta) {
      var mn = parseInt(eta.dataset.min, 10), mx = parseInt(eta.dataset.max, 10);
      if (!isNaN(mn) && !isNaN(mx) && mx >= mn) {
        var f = function (d) { return d.toLocaleDateString(data.locale || undefined, { month: 'short', day: 'numeric' }); };
        var workdays = function (n) { var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; } return d; };
        eta.querySelector('[data-hhp-eta-dates]').textContent = f(workdays(mn)) + ' – ' + f(workdays(mx));
        eta.hidden = false;
      }
    }
  }

  // reveal hh-pdp sections as they scroll in
  function reveal() {
    if (window.__hhpReveal || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    window.__hhpReveal = true;
    document.documentElement.classList.add('hhp-js');
    var els = document.querySelectorAll('[data-reveal]');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('in'); }); }, 4000);
  }

  function boot() { document.querySelectorAll('[data-hhp-main]').forEach(init); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
